import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const assetUrl = (src) => (src && src.startsWith("/api") ? `${BACKEND}${src}` : src);

// Photos de chantier : object storage (path) ou asset statique démo (url)
export const photoUrl = (p) =>
  p?.path ? `${BACKEND}/api/chantier-photos/${p.path}` : assetUrl(p?.url);

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

let refreshPromise = null;
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config || {};
    const url = config.url || "";
    if (error.response?.status !== 401 || config.__retried || url.includes("/auth/login") || url.includes("/auth/refresh")) {
      return Promise.reject(error);
    }
    config.__retried = true;
    try {
      refreshPromise = refreshPromise || api.post("/auth/refresh").finally(() => { refreshPromise = null; });
      await refreshPromise;
      return api(config);
    } catch {
      return Promise.reject(error);
    }
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
